/**
 * Client-side mirror of server/lib/buildCrossSignals.js for Enrollment tab UI.
 */
export const buildCrossSignals = (classDemand = []) => {
  const signals = [];

  classDemand
    .filter(
      (row) =>
        row.isWaitlist &&
        ((row.waitlistClicks || 0) > 0 || (row.registerClicks || 0) > 0)
    )
    .slice(0, 4)
    .forEach((row) => {
      signals.push({
        key: `full-${row.id || row.name}`,
        tone: "demand",
        text: `${row.name} (${row.days} ${row.time}) is full in Jackrabbit and got ${row.waitlistClicks || 0} waitlist / ${row.registerClicks || 0} register clicks online.`,
      });
    });

  classDemand
    .filter(
      (row) =>
        !row.isWaitlist &&
        row.openings >= 5 &&
        !(row.registerClicks || row.waitlistClicks)
    )
    .slice(0, 3)
    .forEach((row) => {
      signals.push({
        key: `open-${row.id || row.name}`,
        tone: "promote",
        text: `${row.name} has ${row.openings} openings in Jackrabbit but no website clicks yet — worth promoting.`,
      });
    });

  return signals;
};
